import { a as ir, c as J, g as or } from "./_commonjsHelpers-BkfeUUK-.js";
import { setLibraryLocale as sr } from "./composables.es.js";
var Oe = { exports: {} }, B = "top", W = "bottom", z = "right", H = "left", Ot = "auto", pt = [B, W, z, H], it = "start", at = "end", xe = "clippingParents", Ft = "viewport", st = "popper", Te = "reference", $t = /* @__PURE__ */ pt.reduce(function(t, e) {
  return t.concat([e + "-" + it, e + "-" + at]);
}, []), Bt = /* @__PURE__ */ [].concat(pt, [Ot]).reduce(function(t, e) {
  return t.concat([e, e + "-" + it, e + "-" + at]);
}, []), Ae = "beforeRead", Ce = "read", De = "afterRead", Se = "beforeMain", Ne = "main", Pe = "afterMain", Re = "beforeWrite", Le = "write", Me = "afterWrite", Ie = [Ae, Ce, De, Se, Ne, Pe, Re, Le, Me];
function G(t) {
  return t ? (t.nodeName || "").toLowerCase() : null;
}
function U(t) {
  if (t == null)
    return window;
  if (t.toString() !== "[object Window]") {
    var e = t.ownerDocument;
    return e && e.defaultView || window;
  }
  return t;
}
function ot(t) {
  var e = U(t).Element;
  return t instanceof e || t instanceof Element;
}
function K(t) {
  var e = U(t).HTMLElement;
  return t instanceof e || t instanceof HTMLElement;
}
function Ht(t) {
  if (typeof ShadowRoot > "u")
    return !1;
  var e = U(t).ShadowRoot;
  return t instanceof e || t instanceof ShadowRoot;
}
function ar(t) {
  var e = t.state;
  Object.keys(e.elements).forEach(function(r) {
    var n = e.styles[r] || {}, i = e.attributes[r] || {}, o = e.elements[r];
    !K(o) || !G(o) || (Object.assign(o.style, n), Object.keys(i).forEach(function(s) {
      var a = i[s];
      a === !1 ? o.removeAttribute(s) : o.setAttribute(s, a === !0 ? "" : a);
    }));
  });
}
function cr(t) {
  var e = t.state, r = {
    popper: {
      position: e.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(e.elements.popper.style, r.popper), e.styles = r, e.elements.arrow && Object.assign(e.elements.arrow.style, r.arrow), function() {
    Object.keys(e.elements).forEach(function(n) {
      var i = e.elements[n], o = e.attributes[n] || {}, s = Object.keys(e.styles.hasOwnProperty(n) ? e.styles[n] : r[n]), a = s.reduce(function(l, u) {
        return l[u] = "", l;
      }, {});
      !K(i) || !G(i) || (Object.assign(i.style, a), Object.keys(o).forEach(function(l) {
        i.removeAttribute(l);
      }));
    });
  };
}
const qt = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: ar,
  effect: cr,
  requires: ["computeStyles"]
};
function X(t) {
  return t.split("-")[0];
}
var nt = Math.max, Et = Math.min, ct = Math.round;
function kt() {
  var t = navigator.userAgentData;
  return t != null && t.brands && Array.isArray(t.brands) ? t.brands.map(function(e) {
    return e.brand + "/" + e.version;
  }).join(" ") : navigator.userAgent;
}
function $e() {
  return !/^((?!chrome|android).)*safari/i.test(kt());
}
function lt(t, e, r) {
  e === void 0 && (e = !1), r === void 0 && (r = !1);
  var n = t.getBoundingClientRect(), i = 1, o = 1;
  e && K(t) && (i = t.offsetWidth > 0 && ct(n.width) / t.offsetWidth || 1, o = t.offsetHeight > 0 && ct(n.height) / t.offsetHeight || 1);
  var s = ot(t) ? U(t) : window, a = s.visualViewport, l = !$e() && r, u = (n.left + (l && a ? a.offsetLeft : 0)) / i, f = (n.top + (l && a ? a.offsetTop : 0)) / o, E = n.width / i, b = n.height / o;
  return {
    width: E,
    height: b,
    top: f,
    right: u + E,
    bottom: f + b,
    left: u,
    x: u,
    y: f
  };
}
function Vt(t) {
  var e = lt(t), r = t.offsetWidth, n = t.offsetHeight;
  return Math.abs(e.width - r) <= 1 && (r = e.width), Math.abs(e.height - n) <= 1 && (n = e.height), {
    x: t.offsetLeft,
    y: t.offsetTop,
    width: r,
    height: n
  };
}
function ke(t, e) {
  var r = e.getRootNode && e.getRootNode();
  if (t.contains(e))
    return !0;
  if (r && Ht(r)) {
    var n = e;
    do {
      if (n && t.isSameNode(n))
        return !0;
      n = n.parentNode || n.host;
    } while (n);
  }
  return !1;
}
function tt(t) {
  return U(t).getComputedStyle(t);
}
function lr(t) {
  return ["table", "td", "th"].indexOf(G(t)) >= 0;
}
function et(t) {
  return ((ot(t) ? t.ownerDocument : (
    // $FlowFixMe[prop-missing]
    t.document
  )) || window.document).documentElement;
}
function xt(t) {
  return G(t) === "html" ? t : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    t.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    t.parentNode || // DOM Element detected
    (Ht(t) ? t.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    et(t)
  );
}
function se(t) {
  return !K(t) || // https://github.com/popperjs/popper-core/issues/837
  tt(t).position === "fixed" ? null : t.offsetParent;
}
function ur(t) {
  var e = /firefox/i.test(kt()), r = /Trident/i.test(kt());
  if (r && K(t)) {
    var n = tt(t);
    if (n.position === "fixed")
      return null;
  }
  var i = xt(t);
  for (Ht(i) && (i = i.host); K(i) && ["html", "body"].indexOf(G(i)) < 0; ) {
    var o = tt(i);
    if (o.transform !== "none" || o.perspective !== "none" || o.contain === "paint" || ["transform", "perspective"].indexOf(o.willChange) !== -1 || e && o.willChange === "filter" || e && o.filter && o.filter !== "none")
      return i;
    i = i.parentNode;
  }
  return null;
}
function mt(t) {
  for (var e = U(t), r = se(t); r && lr(r) && tt(r).position === "static"; )
    r = se(r);
  return r && (G(r) === "html" || G(r) === "body" && tt(r).position === "static") ? e : r || ur(t) || e;
}
function Wt(t) {
  return ["top", "bottom"].indexOf(t) >= 0 ? "x" : "y";
}
function ht(t, e, r) {
  return nt(t, Et(e, r));
}
function fr(t, e, r) {
  var n = ht(t, e, r);
  return n > r ? r : n;
}
function je() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Fe(t) {
  return Object.assign({}, je(), t);
}
function Be(t, e) {
  return e.reduce(function(r, n) {
    return r[n] = t, r;
  }, {});
}
var pr = function(e, r) {
  return e = typeof e == "function" ? e(Object.assign({}, r.rects, {
    placement: r.placement
  })) : e, Fe(typeof e != "number" ? e : Be(e, pt));
};
function dr(t) {
  var e, r = t.state, n = t.name, i = t.options, o = r.elements.arrow, s = r.modifiersData.popperOffsets, a = X(r.placement), l = Wt(a), u = [H, z].indexOf(a) >= 0, f = u ? "height" : "width";
  if (!(!o || !s)) {
    var E = pr(i.padding, r), b = Vt(o), g = l === "y" ? B : H, A = l === "y" ? W : z, _ = r.rects.reference[f] + r.rects.reference[l] - s[l] - r.rects.popper[f], T = s[l] - r.rects.reference[l], S = mt(o), P = S ? l === "y" ? S.clientHeight || 0 : S.clientWidth || 0 : 0, D = _ / 2 - T / 2, O = E[g], N = P - b[f] - E[A], p = P / 2 - b[f] / 2 + D, h = ht(O, p, N), y = l;
    r.modifiersData[n] = (e = {}, e[y] = h, e.centerOffset = h - p, e);
  }
}
function hr(t) {
  var e = t.state, r = t.options, n = r.element, i = n === void 0 ? "[data-popper-arrow]" : n;
  i != null && (typeof i == "string" && (i = e.elements.popper.querySelector(i), !i) || ke(e.elements.popper, i) && (e.elements.arrow = i));
}
const He = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: dr,
  effect: hr,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function ut(t) {
  return t.split("-")[1];
}
var vr = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function mr(t, e) {
  var r = t.x, n = t.y, i = e.devicePixelRatio || 1;
  return {
    x: ct(r * i) / i || 0,
    y: ct(n * i) / i || 0
  };
}
function ae(t) {
  var e, r = t.popper, n = t.popperRect, i = t.placement, o = t.variation, s = t.offsets, a = t.position, l = t.gpuAcceleration, u = t.adaptive, f = t.roundOffsets, E = t.isFixed, b = s.x, g = b === void 0 ? 0 : b, A = s.y, _ = A === void 0 ? 0 : A, T = typeof f == "function" ? f({
    x: g,
    y: _
  }) : {
    x: g,
    y: _
  };
  g = T.x, _ = T.y;
  var S = s.hasOwnProperty("x"), P = s.hasOwnProperty("y"), D = H, O = B, N = window;
  if (u) {
    var p = mt(r), h = "clientHeight", y = "clientWidth";
    if (p === U(r) && (p = et(r), tt(p).position !== "static" && a === "absolute" && (h = "scrollHeight", y = "scrollWidth")), p = p, i === B || (i === H || i === z) && o === at) {
      O = W;
      var w = E && p === N && N.visualViewport ? N.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        p[h]
      );
      _ -= w - n.height, _ *= l ? 1 : -1;
    }
    if (i === H || (i === B || i === W) && o === at) {
      D = z;
      var c = E && p === N && N.visualViewport ? N.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        p[y]
      );
      g -= c - n.width, g *= l ? 1 : -1;
    }
  }
  var v = Object.assign({
    position: a
  }, u && vr), m = f === !0 ? mr({
    x: g,
    y: _
  }, U(r)) : {
    x: g,
    y: _
  };
  if (g = m.x, _ = m.y, l) {
    var C;
    return Object.assign({}, v, (C = {}, C[O] = P ? "0" : "", C[D] = S ? "0" : "", C.transform = (N.devicePixelRatio || 1) <= 1 ? "translate(" + g + "px, " + _ + "px)" : "translate3d(" + g + "px, " + _ + "px, 0)", C));
  }
  return Object.assign({}, v, (e = {}, e[O] = P ? _ + "px" : "", e[D] = S ? g + "px" : "", e.transform = "", e));
}
function gr(t) {
  var e = t.state, r = t.options, n = r.gpuAcceleration, i = n === void 0 ? !0 : n, o = r.adaptive, s = o === void 0 ? !0 : o, a = r.roundOffsets, l = a === void 0 ? !0 : a, u = {
    placement: X(e.placement),
    variation: ut(e.placement),
    popper: e.elements.popper,
    popperRect: e.rects.popper,
    gpuAcceleration: i,
    isFixed: e.options.strategy === "fixed"
  };
  e.modifiersData.popperOffsets != null && (e.styles.popper = Object.assign({}, e.styles.popper, ae(Object.assign({}, u, {
    offsets: e.modifiersData.popperOffsets,
    position: e.options.strategy,
    adaptive: s,
    roundOffsets: l
  })))), e.modifiersData.arrow != null && (e.styles.arrow = Object.assign({}, e.styles.arrow, ae(Object.assign({}, u, {
    offsets: e.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-placement": e.placement
  });
}
const zt = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: gr,
  data: {}
};
var bt = {
  passive: !0
};
function br(t) {
  var e = t.state, r = t.instance, n = t.options, i = n.scroll, o = i === void 0 ? !0 : i, s = n.resize, a = s === void 0 ? !0 : s, l = U(e.elements.popper), u = [].concat(e.scrollParents.reference, e.scrollParents.popper);
  return o && u.forEach(function(f) {
    f.addEventListener("scroll", r.update, bt);
  }), a && l.addEventListener("resize", r.update, bt), function() {
    o && u.forEach(function(f) {
      f.removeEventListener("scroll", r.update, bt);
    }), a && l.removeEventListener("resize", r.update, bt);
  };
}
const Ut = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: br,
  data: {}
};
var yr = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function wt(t) {
  return t.replace(/left|right|bottom|top/g, function(e) {
    return yr[e];
  });
}
var _r = {
  start: "end",
  end: "start"
};
function ce(t) {
  return t.replace(/start|end/g, function(e) {
    return _r[e];
  });
}
function Yt(t) {
  var e = U(t), r = e.pageXOffset, n = e.pageYOffset;
  return {
    scrollLeft: r,
    scrollTop: n
  };
}
function Kt(t) {
  return lt(et(t)).left + Yt(t).scrollLeft;
}
function wr(t, e) {
  var r = U(t), n = et(t), i = r.visualViewport, o = n.clientWidth, s = n.clientHeight, a = 0, l = 0;
  if (i) {
    o = i.width, s = i.height;
    var u = $e();
    (u || !u && e === "fixed") && (a = i.offsetLeft, l = i.offsetTop);
  }
  return {
    width: o,
    height: s,
    x: a + Kt(t),
    y: l
  };
}
function Er(t) {
  var e, r = et(t), n = Yt(t), i = (e = t.ownerDocument) == null ? void 0 : e.body, o = nt(r.scrollWidth, r.clientWidth, i ? i.scrollWidth : 0, i ? i.clientWidth : 0), s = nt(r.scrollHeight, r.clientHeight, i ? i.scrollHeight : 0, i ? i.clientHeight : 0), a = -n.scrollLeft + Kt(t), l = -n.scrollTop;
  return tt(i || r).direction === "rtl" && (a += nt(r.clientWidth, i ? i.clientWidth : 0) - o), {
    width: o,
    height: s,
    x: a,
    y: l
  };
}
function Qt(t) {
  var e = tt(t), r = e.overflow, n = e.overflowX, i = e.overflowY;
  return /auto|scroll|overlay|hidden/.test(r + i + n);
}
function qe(t) {
  return ["html", "body", "#document"].indexOf(G(t)) >= 0 ? t.ownerDocument.body : K(t) && Qt(t) ? t : qe(xt(t));
}
function vt(t, e) {
  var r;
  e === void 0 && (e = []);
  var n = qe(t), i = n === ((r = t.ownerDocument) == null ? void 0 : r.body), o = U(n), s = i ? [o].concat(o.visualViewport || [], Qt(n) ? n : []) : n, a = e.concat(s);
  return i ? a : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    a.concat(vt(xt(s)))
  );
}
function jt(t) {
  return Object.assign({}, t, {
    left: t.x,
    top: t.y,
    right: t.x + t.width,
    bottom: t.y + t.height
  });
}
function Or(t, e) {
  var r = lt(t, !1, e === "fixed");
  return r.top = r.top + t.clientTop, r.left = r.left + t.clientLeft, r.bottom = r.top + t.clientHeight, r.right = r.left + t.clientWidth, r.width = t.clientWidth, r.height = t.clientHeight, r.x = r.left, r.y = r.top, r;
}
function le(t, e, r) {
  return e === Ft ? jt(wr(t, r)) : ot(e) ? Or(e, r) : jt(Er(et(t)));
}
function xr(t) {
  var e = vt(xt(t)), r = ["absolute", "fixed"].indexOf(tt(t).position) >= 0, n = r && K(t) ? mt(t) : t;
  return ot(n) ? e.filter(function(i) {
    return ot(i) && ke(i, n) && G(i) !== "body";
  }) : [];
}
function Tr(t, e, r, n) {
  var i = e === "clippingParents" ? xr(t) : [].concat(e), o = [].concat(i, [r]), s = o[0], a = o.reduce(function(l, u) {
    var f = le(t, u, n);
    return l.top = nt(f.top, l.top), l.right = Et(f.right, l.right), l.bottom = Et(f.bottom, l.bottom), l.left = nt(f.left, l.left), l;
  }, le(t, s, n));
  return a.width = a.right - a.left, a.height = a.bottom - a.top, a.x = a.left, a.y = a.top, a;
}
function Ve(t) {
  var e = t.reference, r = t.element, n = t.placement, i = n ? X(n) : null, o = n ? ut(n) : null, s = e.x + e.width / 2 - r.width / 2, a = e.y + e.height / 2 - r.height / 2, l;
  switch (i) {
    case B:
      l = {
        x: s,
        y: e.y - r.height
      };
      break;
    case W:
      l = {
        x: s,
        y: e.y + e.height
      };
      break;
    case z:
      l = {
        x: e.x + e.width,
        y: a
      };
      break;
    case H:
      l = {
        x: e.x - r.width,
        y: a
      };
      break;
    default:
      l = {
        x: e.x,
        y: e.y
      };
  }
  var u = i ? Wt(i) : null;
  if (u != null) {
    var f = u === "y" ? "height" : "width";
    switch (o) {
      case it:
        l[u] = l[u] - (e[f] / 2 - r[f] / 2);
        break;
      case at:
        l[u] = l[u] + (e[f] / 2 - r[f] / 2);
        break;
    }
  }
  return l;
}
function ft(t, e) {
  e === void 0 && (e = {});
  var r = e, n = r.placement, i = n === void 0 ? t.placement : n, o = r.strategy, s = o === void 0 ? t.strategy : o, a = r.boundary, l = a === void 0 ? xe : a, u = r.rootBoundary, f = u === void 0 ? Ft : u, E = r.elementContext, b = E === void 0 ? st : E, g = r.altBoundary, A = g === void 0 ? !1 : g, _ = r.padding, T = _ === void 0 ? 0 : _, S = Fe(typeof T != "number" ? T : Be(T, pt)), P = b === st ? Te : st, D = t.rects.popper, O = t.elements[A ? P : b], N = Tr(ot(O) ? O : O.contextElement || et(t.elements.popper), l, f, s), p = lt(t.elements.reference), h = Ve({
    reference: p,
    element: D,
    strategy: "absolute",
    placement: i
  }), y = jt(Object.assign({}, D, h)), w = b === st ? y : p, c = {
    top: N.top - w.top + S.top,
    bottom: w.bottom - N.bottom + S.bottom,
    left: N.left - w.left + S.left,
    right: w.right - N.right + S.right
  }, v = t.modifiersData.offset;
  if (b === st && v) {
    var m = v[i];
    Object.keys(c).forEach(function(C) {
      var R = [z, W].indexOf(C) >= 0 ? 1 : -1, I = [B, W].indexOf(C) >= 0 ? "y" : "x";
      c[C] += m[I] * R;
    });
  }
  return c;
}
function Ar(t, e) {
  e === void 0 && (e = {});
  var r = e, n = r.placement, i = r.boundary, o = r.rootBoundary, s = r.padding, a = r.flipVariations, l = r.allowedAutoPlacements, u = l === void 0 ? Bt : l, f = ut(n), E = f ? a ? $t : $t.filter(function(A) {
    return ut(A) === f;
  }) : pt, b = E.filter(function(A) {
    return u.indexOf(A) >= 0;
  });
  b.length === 0 && (b = E);
  var g = b.reduce(function(A, _) {
    return A[_] = ft(t, {
      placement: _,
      boundary: i,
      rootBoundary: o,
      padding: s
    })[X(_)], A;
  }, {});
  return Object.keys(g).sort(function(A, _) {
    return g[A] - g[_];
  });
}
function Cr(t) {
  if (X(t) === Ot)
    return [];
  var e = wt(t);
  return [ce(t), e, ce(e)];
}
function Dr(t) {
  var e = t.state, r = t.options, n = t.name;
  if (!e.modifiersData[n]._skip) {
    for (var i = r.mainAxis, o = i === void 0 ? !0 : i, s = r.altAxis, a = s === void 0 ? !0 : s, l = r.fallbackPlacements, u = r.padding, f = r.boundary, E = r.rootBoundary, b = r.altBoundary, g = r.flipVariations, A = g === void 0 ? !0 : g, _ = r.allowedAutoPlacements, T = e.options.placement, S = X(T), P = S === T, D = l || (P || !A ? [wt(T)] : Cr(T)), O = [T].concat(D).reduce(function(M, k) {
      return M.concat(X(k) === Ot ? Ar(e, {
        placement: k,
        boundary: f,
        rootBoundary: E,
        padding: u,
        flipVariations: A,
        allowedAutoPlacements: _
      }) : k);
    }, []), N = e.rects.reference, p = e.rects.popper, h = /* @__PURE__ */ new Map(), y = !0, w = O[0], c = 0; c < O.length; c++) {
      var v = O[c], m = X(v), C = ut(v) === it, R = [B, W].indexOf(m) >= 0, I = R ? "width" : "height", L = ft(e, {
        placement: v,
        boundary: f,
        rootBoundary: E,
        altBoundary: b,
        padding: u
      }), $ = R ? C ? z : H : C ? W : B;
      N[I] > p[I] && ($ = wt($));
      var j = wt($), Y = [];
      if (o && Y.push(L[m] <= 0), a && Y.push(L[$] <= 0, L[j] <= 0), Y.every(function(M) {
        return M;
      })) {
        w = v, y = !1;
        break;
      }
      h.set(v, Y);
    }
    if (y)
      for (var Q = A ? 3 : 1, F = function(k) {
        var q = O.find(function(V) {
          var Z = h.get(V);
          if (Z)
            return Z.slice(0, k).every(function(At) {
              return At;
            });
        });
        if (q)
          return w = q, "break";
      }, d = Q; d > 0; d--) {
        var x = F(d);
        if (x === "break") break;
      }
    e.placement !== w && (e.modifiersData[n]._skip = !0, e.placement = w, e.reset = !0);
  }
}
const We = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: Dr,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function ue(t, e, r) {
  return r === void 0 && (r = {
    x: 0,
    y: 0
  }), {
    top: t.top - e.height - r.y,
    right: t.right - e.width + r.x,
    bottom: t.bottom - e.height + r.y,
    left: t.left - e.width - r.x
  };
}
function fe(t) {
  return [B, z, W, H].some(function(e) {
    return t[e] >= 0;
  });
}
function Sr(t) {
  var e = t.state, r = t.name, n = e.rects.reference, i = e.rects.popper, o = e.modifiersData.preventOverflow, s = ft(e, {
    elementContext: "reference"
  }), a = ft(e, {
    altBoundary: !0
  }), l = ue(s, n), u = ue(a, i, o), f = fe(l), E = fe(u);
  e.modifiersData[r] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: u,
    isReferenceHidden: f,
    hasPopperEscaped: E
  }, e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-reference-hidden": f,
    "data-popper-escaped": E
  });
}
const ze = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: Sr
};
function Nr(t, e, r) {
  var n = X(t), i = [H, B].indexOf(n) >= 0 ? -1 : 1, o = typeof r == "function" ? r(Object.assign({}, e, {
    placement: t
  })) : r, s = o[0], a = o[1];
  return s = s || 0, a = (a || 0) * i, [H, z].indexOf(n) >= 0 ? {
    x: a,
    y: s
  } : {
    x: s,
    y: a
  };
}
function Pr(t) {
  var e = t.state, r = t.options, n = t.name, i = r.offset, o = i === void 0 ? [0, 0] : i, s = Bt.reduce(function(f, E) {
    return f[E] = Nr(E, e.rects, o), f;
  }, {}), a = s[e.placement], l = a.x, u = a.y;
  e.modifiersData.popperOffsets != null && (e.modifiersData.popperOffsets.x += l, e.modifiersData.popperOffsets.y += u), e.modifiersData[n] = s;
}
const Ue = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: Pr
};
function Rr(t) {
  var e = t.state, r = t.name;
  e.modifiersData[r] = Ve({
    reference: e.rects.reference,
    element: e.rects.popper,
    strategy: "absolute",
    placement: e.placement
  });
}
const Xt = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: Rr,
  data: {}
};
function Lr(t) {
  return t === "x" ? "y" : "x";
}
function Mr(t) {
  var e = t.state, r = t.options, n = t.name, i = r.mainAxis, o = i === void 0 ? !0 : i, s = r.altAxis, a = s === void 0 ? !1 : s, l = r.boundary, u = r.rootBoundary, f = r.altBoundary, E = r.padding, b = r.tether, g = b === void 0 ? !0 : b, A = r.tetherOffset, _ = A === void 0 ? 0 : A, T = ft(e, {
    boundary: l,
    rootBoundary: u,
    padding: E,
    altBoundary: f
  }), S = X(e.placement), P = ut(e.placement), D = !P, O = Wt(S), N = Lr(O), p = e.modifiersData.popperOffsets, h = e.rects.reference, y = e.rects.popper, w = typeof _ == "function" ? _(Object.assign({}, e.rects, {
    placement: e.placement
  })) : _, c = typeof w == "number" ? {
    mainAxis: w,
    altAxis: w
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, w), v = e.modifiersData.offset ? e.modifiersData.offset[e.placement] : null, m = {
    x: 0,
    y: 0
  };
  if (p) {
    if (o) {
      var C, R = O === "y" ? B : H, I = O === "y" ? W : z, L = O === "y" ? "height" : "width", $ = p[O], j = $ + T[R], Y = $ - T[I], Q = g ? -y[L] / 2 : 0, F = P === it ? h[L] : y[L], d = P === it ? -y[L] : -h[L], x = e.elements.arrow, M = g && x ? Vt(x) : {
        width: 0,
        height: 0
      }, k = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : je(), q = k[R], V = k[I], Z = ht(0, h[L], M[L]), At = D ? h[L] / 2 - Q - Z - q - c.mainAxis : F - Z - q - c.mainAxis, Je = D ? -h[L] / 2 + Q + Z + V + c.mainAxis : d + Z + V + c.mainAxis, Ct = e.elements.arrow && mt(e.elements.arrow), Ze = Ct ? O === "y" ? Ct.clientTop || 0 : Ct.clientLeft || 0 : 0, Gt = (C = v == null ? void 0 : v[O]) != null ? C : 0, tr = $ + At - Gt - Ze, er = $ + Je - Gt, Jt = ht(g ? Et(j, tr) : j, $, g ? nt(Y, er) : Y);
      p[O] = Jt, m[O] = Jt - $;
    }
    if (a) {
      var Zt, rr = O === "x" ? B : H, nr = O === "x" ? W : z, rt = p[N], gt = N === "y" ? "height" : "width", te = rt + T[rr], ee = rt - T[nr], Dt = [B, H].indexOf(S) !== -1, re = (Zt = v == null ? void 0 : v[N]) != null ? Zt : 0, ne = Dt ? te : rt - h[gt] - y[gt] - re + c.altAxis, ie = Dt ? rt + h[gt] + y[gt] - re - c.altAxis : ee, oe = g && Dt ? fr(ne, rt, ie) : ht(g ? ne : te, rt, g ? ie : ee);
      p[N] = oe, m[N] = oe - rt;
    }
    e.modifiersData[n] = m;
  }
}
const Ye = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: Mr,
  requiresIfExists: ["offset"]
};
function Ir(t) {
  return {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  };
}
function $r(t) {
  return t === U(t) || !K(t) ? Yt(t) : Ir(t);
}
function kr(t) {
  var e = t.getBoundingClientRect(), r = ct(e.width) / t.offsetWidth || 1, n = ct(e.height) / t.offsetHeight || 1;
  return r !== 1 || n !== 1;
}
function jr(t, e, r) {
  r === void 0 && (r = !1);
  var n = K(e), i = K(e) && kr(e), o = et(e), s = lt(t, i, r), a = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (n || !n && !r) && ((G(e) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Qt(o)) && (a = $r(e)), K(e) ? (l = lt(e, !0), l.x += e.clientLeft, l.y += e.clientTop) : o && (l.x = Kt(o))), {
    x: s.left + a.scrollLeft - l.x,
    y: s.top + a.scrollTop - l.y,
    width: s.width,
    height: s.height
  };
}
function Fr(t) {
  var e = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set(), n = [];
  t.forEach(function(o) {
    e.set(o.name, o);
  });
  function i(o) {
    r.add(o.name);
    var s = [].concat(o.requires || [], o.requiresIfExists || []);
    s.forEach(function(a) {
      if (!r.has(a)) {
        var l = e.get(a);
        l && i(l);
      }
    }), n.push(o);
  }
  return t.forEach(function(o) {
    r.has(o.name) || i(o);
  }), n;
}
function Br(t) {
  var e = Fr(t);
  return Ie.reduce(function(r, n) {
    return r.concat(e.filter(function(i) {
      return i.phase === n;
    }));
  }, []);
}
function Hr(t) {
  var e;
  return function() {
    return e || (e = new Promise(function(r) {
      Promise.resolve().then(function() {
        e = void 0, r(t());
      });
    })), e;
  };
}
function qr(t) {
  var e = t.reduce(function(r, n) {
    var i = r[n.name];
    return r[n.name] = i ? Object.assign({}, i, n, {
      options: Object.assign({}, i.options, n.options),
      data: Object.assign({}, i.data, n.data)
    }) : n, r;
  }, {});
  return Object.keys(e).map(function(r) {
    return e[r];
  });
}
var pe = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function de() {
  for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++)
    e[r] = arguments[r];
  return !e.some(function(n) {
    return !(n && typeof n.getBoundingClientRect == "function");
  });
}
function Tt(t) {
  t === void 0 && (t = {});
  var e = t, r = e.defaultModifiers, n = r === void 0 ? [] : r, i = e.defaultOptions, o = i === void 0 ? pe : i;
  return function(a, l, u) {
    u === void 0 && (u = o);
    var f = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, pe, o),
      modifiersData: {},
      elements: {
        reference: a,
        popper: l
      },
      attributes: {},
      styles: {}
    }, E = [], b = !1, g = {
      state: f,
      setOptions: function(S) {
        var P = typeof S == "function" ? S(f.options) : S;
        _(), f.options = Object.assign({}, o, f.options, P), f.scrollParents = {
          reference: ot(a) ? vt(a) : a.contextElement ? vt(a.contextElement) : [],
          popper: vt(l)
        };
        var D = Br(qr([].concat(n, f.options.modifiers)));
        return f.orderedModifiers = D.filter(function(O) {
          return O.enabled;
        }), A(), g.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!b) {
          var S = f.elements, P = S.reference, D = S.popper;
          if (de(P, D)) {
            f.rects = {
              reference: jr(P, mt(D), f.options.strategy === "fixed"),
              popper: Vt(D)
            }, f.reset = !1, f.placement = f.options.placement, f.orderedModifiers.forEach(function(c) {
              return f.modifiersData[c.name] = Object.assign({}, c.data);
            });
            for (var O = 0; O < f.orderedModifiers.length; O++) {
              if (f.reset === !0) {
                f.reset = !1, O = -1;
                continue;
              }
              var N = f.orderedModifiers[O], p = N.fn, h = N.options, y = h === void 0 ? {} : h, w = N.name;
              typeof p == "function" && (f = p({
                state: f,
                options: y,
                name: w,
                instance: g
              }) || f);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: Hr(function() {
        return new Promise(function(T) {
          g.forceUpdate(), T(f);
        });
      }),
      destroy: function() {
        _(), b = !0;
      }
    };
    if (!de(a, l))
      return g;
    g.setOptions(u).then(function(T) {
      !b && u.onFirstUpdate && u.onFirstUpdate(T);
    });
    function A() {
      f.orderedModifiers.forEach(function(T) {
        var S = T.name, P = T.options, D = P === void 0 ? {} : P, O = T.effect;
        if (typeof O == "function") {
          var N = O({
            state: f,
            name: S,
            instance: g,
            options: D
          }), p = function() {
          };
          E.push(N || p);
        }
      });
    }
    function _() {
      E.forEach(function(T) {
        return T();
      }), E = [];
    }
    return g;
  };
}
var Vr = /* @__PURE__ */ Tt(), Wr = [Ut, Xt, zt, qt], zr = /* @__PURE__ */ Tt({
  defaultModifiers: Wr
}), Ur = [Ut, Xt, zt, qt, Ue, We, Ye, He, ze], Yr = /* @__PURE__ */ Tt({
  defaultModifiers: Ur
});
const Kr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  afterMain: Pe,
  afterRead: De,
  afterWrite: Me,
  applyStyles: qt,
  arrow: He,
  auto: Ot,
  basePlacements: pt,
  beforeMain: Se,
  beforeRead: Ae,
  beforeWrite: Re,
  bottom: W,
  clippingParents: xe,
  computeStyles: zt,
  createPopper: Yr,
  createPopperBase: Vr,
  createPopperLite: zr,
  detectOverflow: ft,
  end: at,
  eventListeners: Ut,
  flip: We,
  hide: ze,
  left: H,
  main: Ne,
  modifierPhases: Ie,
  offset: Ue,
  placements: Bt,
  popper: st,
  popperGenerator: Tt,
  popperOffsets: Xt,
  preventOverflow: Ye,
  read: Ce,
  reference: Te,
  right: z,
  start: it,
  top: B,
  variationPlacements: $t,
  viewport: Ft,
  write: Le
}, Symbol.toStringTag, { value: "Module" })), Qr = /* @__PURE__ */ ir(Kr);
var St = { exports: {} }, Nt = { exports: {} };
/*!
  * Bootstrap data.js v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */
var he;
function Xr() {
  return he || (he = 1, function(t, e) {
    (function(r, n) {
      t.exports = n();
    })(J, function() {
      const r = /* @__PURE__ */ new Map();
      return {
        set(i, o, s) {
          r.has(i) || r.set(i, /* @__PURE__ */ new Map());
          const a = r.get(i);
          if (!a.has(o) && a.size !== 0) {
            console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(a.keys())[0]}.`);
            return;
          }
          a.set(o, s);
        },
        get(i, o) {
          return r.has(i) && r.get(i).get(o) || null;
        },
        remove(i, o) {
          if (!r.has(i))
            return;
          const s = r.get(i);
          s.delete(o), s.size === 0 && r.delete(i);
        }
      };
    });
  }(Nt)), Nt.exports;
}
var Pt = { exports: {} }, yt = { exports: {} };
/*!
  * Bootstrap index.js v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */
var ve;
function dt() {
  return ve || (ve = 1, function(t, e) {
    (function(r, n) {
      n(e);
    })(J, function(r) {
      const o = "transitionend", s = (c) => (c && window.CSS && window.CSS.escape && (c = c.replace(/#([^\s"#']+)/g, (v, m) => `#${CSS.escape(m)}`)), c), a = (c) => c == null ? `${c}` : Object.prototype.toString.call(c).match(/\s([a-z]+)/i)[1].toLowerCase(), l = (c) => {
        do
          c += Math.floor(Math.random() * 1e6);
        while (document.getElementById(c));
        return c;
      }, u = (c) => {
        if (!c)
          return 0;
        let {
          transitionDuration: v,
          transitionDelay: m
        } = window.getComputedStyle(c);
        const C = Number.parseFloat(v), R = Number.parseFloat(m);
        return !C && !R ? 0 : (v = v.split(",")[0], m = m.split(",")[0], (Number.parseFloat(v) + Number.parseFloat(m)) * 1e3);
      }, f = (c) => {
        c.dispatchEvent(new Event(o));
      }, E = (c) => !c || typeof c != "object" ? !1 : (typeof c.jquery < "u" && (c = c[0]), typeof c.nodeType < "u"), b = (c) => E(c) ? c.jquery ? c[0] : c : typeof c == "string" && c.length > 0 ? document.querySelector(s(c)) : null, g = (c) => {
        if (!E(c) || c.getClientRects().length === 0)
          return !1;
        const v = getComputedStyle(c).getPropertyValue("visibility") === "visible", m = c.closest("details:not([open])");
        if (!m)
          return v;
        if (m !== c) {
          const C = c.closest("summary");
          if (C && C.parentNode !== m || C === null)
            return !1;
        }
        return v;
      }, A = (c) => !c || c.nodeType !== Node.ELEMENT_NODE || c.classList.contains("disabled") ? !0 : typeof c.disabled < "u" ? c.disabled : c.hasAttribute("disabled") && c.getAttribute("disabled") !== "false", _ = (c) => {
        if (!document.documentElement.attachShadow)
          return null;
        if (typeof c.getRootNode == "function") {
          const v = c.getRootNode();
          return v instanceof ShadowRoot ? v : null;
        }
        return c instanceof ShadowRoot ? c : c.parentNode ? _(c.parentNode) : null;
      }, T = () => {
      }, S = (c) => {
        c.offsetHeight;
      }, P = () => window.jQuery && !document.body.hasAttribute("data-bs-no-jquery") ? window.jQuery : null, D = [], O = (c) => {
        document.readyState === "loading" ? (D.length || document.addEventListener("DOMContentLoaded", () => {
          for (const v of D)
            v();
        }), D.push(c)) : c();
      }, N = () => document.documentElement.dir === "rtl", p = (c) => {
        O(() => {
          const v = P();
          if (v) {
            const m = c.NAME, C = v.fn[m];
            v.fn[m] = c.jQueryInterface, v.fn[m].Constructor = c, v.fn[m].noConflict = () => (v.fn[m] = C, c.jQueryInterface);
          }
        });
      }, h = (c, v = [], m = c) => typeof c == "function" ? c(...v) : m, y = (c, v, m = !0) => {
        if (!m) {
          h(c);
          return;
        }
        const R = u(v) + 5;
        let I = !1;
        const L = ({
          target: $
        }) => {
          $ === v && (I = !0, v.removeEventListener(o, L), h(c));
        };
        v.addEventListener(o, L), setTimeout(() => {
          I || f(v);
        }, R);
      }, w = (c, v, m, C) => {
        const R = c.length;
        let I = c.indexOf(v);
        return I === -1 ? !m && C ? c[R - 1] : c[0] : (I += m ? 1 : -1, C && (I = (I + R) % R), c[Math.max(0, Math.min(I, R - 1))]);
      };
      r.defineJQueryPlugin = p, r.execute = h, r.executeAfterTransition = y, r.findShadowRoot = _, r.getElement = b, r.getNextActiveElement = w, r.getTransitionDurationFromElement = u, r.getUID = l, r.getjQuery = P, r.isDisabled = A, r.isElement = E, r.isRTL = N, r.isVisible = g, r.noop = T, r.onDOMContentLoaded = O, r.parseSelector = s, r.reflow = S, r.toType = a, r.triggerTransitionEnd = f, Object.defineProperty(r, Symbol.toStringTag, { value: "Module" });
    });
  }(yt, yt.exports)), yt.exports;
}
/*!
  * Bootstrap event-handler.js v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */
var me;
function Ke() {
  return me || (me = 1, function(t, e) {
    (function(r, n) {
      t.exports = n(dt());
    })(J, function(r) {
      const n = /[^.]*(?=\..*)\.|.*/, i = /\..*/, o = /::\d+$/, s = {};
      let a = 1;
      const l = {
        mouseenter: "mouseover",
        mouseleave: "mouseout"
      }, u = /* @__PURE__ */ new Set(["click", "dblclick", "mouseup", "mousedown", "contextmenu", "mousewheel", "DOMMouseScroll", "mouseover", "mouseout", "mousemove", "selectstart", "selectend", "keydown", "keypress", "keyup", "orientationchange", "touchstart", "touchmove", "touchend", "touchcancel", "pointerdown", "pointermove", "pointerup", "pointerleave", "pointercancel", "gesturestart", "gesturechange", "gestureend", "focus", "blur", "change", "reset", "select", "submit", "focusin", "focusout", "load", "unload", "beforeunload", "resize", "move", "DOMContentLoaded", "readystatechange", "error", "abort", "scroll"]);
      function f(p, h) {
        return h && `${h}::${a++}` || p.uidEvent || a++;
      }
      function E(p) {
        const h = f(p);
        return p.uidEvent = h, s[h] = s[h] || {}, s[h];
      }
      function b(p, h) {
        return function y(w) {
          return N(w, {
            delegateTarget: p
          }), y.oneOff && O.off(p, w.type, h), h.apply(p, [w]);
        };
      }
      function g(p, h, y) {
        return function w(c) {
          const v = p.querySelectorAll(h);
          for (let {
            target: m
          } = c; m && m !== this; m = m.parentNode)
            for (const C of v)
              if (C === m)
                return N(c, {
                  delegateTarget: m
                }), w.oneOff && O.off(p, c.type, h, y), y.apply(m, [c]);
        };
      }
      function A(p, h, y = null) {
        return Object.values(p).find((w) => w.callable === h && w.delegationSelector === y);
      }
      function _(p, h, y) {
        const w = typeof h == "string", c = w ? y : h || y;
        let v = D(p);
        return u.has(v) || (v = p), [w, c, v];
      }
      function T(p, h, y, w, c) {
        if (typeof h != "string" || !p)
          return;
        let [v, m, C] = _(h, y, w);
        h in l && (m = ((Q) => function(F) {
          if (!F.relatedTarget || F.relatedTarget !== F.delegateTarget && !F.delegateTarget.contains(F.relatedTarget))
            return Q.call(this, F);
        })(m));
        const R = E(p), I = R[C] || (R[C] = {}), L = A(I, m, v ? y : null);
        if (L) {
          L.oneOff = L.oneOff && c;
          return;
        }
        const $ = f(m, h.replace(n, "")), j = v ? g(p, y, m) : b(p, m);
        j.delegationSelector = v ? y : null, j.callable = m, j.oneOff = c, j.uidEvent = $, I[$] = j, p.addEventListener(C, j, v);
      }
      function S(p, h, y, w, c) {
        const v = A(h[y], w, c);
        v && (p.removeEventListener(y, v, !!c), delete h[y][v.uidEvent]);
      }
      function P(p, h, y, w) {
        const c = h[y] || {};
        for (const [v, m] of Object.entries(c))
          v.includes(w) && S(p, h, y, m.callable, m.delegationSelector);
      }
      function D(p) {
        return p = p.replace(i, ""), l[p] || p;
      }
      const O = {
        on(p, h, y, w) {
          T(p, h, y, w, !1);
        },
        one(p, h, y, w) {
          T(p, h, y, w, !0);
        },
        off(p, h, y, w) {
          if (typeof h != "string" || !p)
            return;
          const [c, v, m] = _(h, y, w), C = m !== h, R = E(p), I = R[m] || {}, L = h.startsWith(".");
          if (typeof v < "u") {
            if (!Object.keys(I).length)
              return;
            S(p, R, m, v, c ? y : null);
            return;
          }
          if (L)
            for (const $ of Object.keys(R))
              P(p, R, $, h.slice(1));
          for (const [$, j] of Object.entries(I)) {
            const Y = $.replace(o, "");
            (!C || h.includes(Y)) && S(p, R, m, j.callable, j.delegationSelector);
          }
        },
        trigger(p, h, y) {
          if (typeof h != "string" || !p)
            return null;
          const w = r.getjQuery(), c = D(h), v = h !== c;
          let m = null, C = !0, R = !0, I = !1;
          v && w && (m = w.Event(h, y), w(p).trigger(m), C = !m.isPropagationStopped(), R = !m.isImmediatePropagationStopped(), I = m.isDefaultPrevented());
          const L = N(new Event(h, {
            bubbles: C,
            cancelable: !0
          }), y);
          return I && L.preventDefault(), R && p.dispatchEvent(L), L.defaultPrevented && m && m.preventDefault(), L;
        }
      };
      function N(p, h = {}) {
        for (const [y, w] of Object.entries(h))
          try {
            p[y] = w;
          } catch {
            Object.defineProperty(p, y, {
              configurable: !0,
              get() {
                return w;
              }
            });
          }
        return p;
      }
      return O;
    });
  }(Pt)), Pt.exports;
}
var Rt = { exports: {} }, Lt = { exports: {} };
/*!
  * Bootstrap manipulator.js v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */
var ge;
function Qe() {
  return ge || (ge = 1, function(t, e) {
    (function(r, n) {
      t.exports = n();
    })(J, function() {
      function r(o) {
        if (o === "true")
          return !0;
        if (o === "false")
          return !1;
        if (o === Number(o).toString())
          return Number(o);
        if (o === "" || o === "null")
          return null;
        if (typeof o != "string")
          return o;
        try {
          return JSON.parse(decodeURIComponent(o));
        } catch {
          return o;
        }
      }
      function n(o) {
        return o.replace(/[A-Z]/g, (s) => `-${s.toLowerCase()}`);
      }
      return {
        setDataAttribute(o, s, a) {
          o.setAttribute(`data-bs-${n(s)}`, a);
        },
        removeDataAttribute(o, s) {
          o.removeAttribute(`data-bs-${n(s)}`);
        },
        getDataAttributes(o) {
          if (!o)
            return {};
          const s = {}, a = Object.keys(o.dataset).filter((l) => l.startsWith("bs") && !l.startsWith("bsConfig"));
          for (const l of a) {
            let u = l.replace(/^bs/, "");
            u = u.charAt(0).toLowerCase() + u.slice(1, u.length), s[u] = r(o.dataset[l]);
          }
          return s;
        },
        getDataAttribute(o, s) {
          return r(o.getAttribute(`data-bs-${n(s)}`));
        }
      };
    });
  }(Lt)), Lt.exports;
}
/*!
  * Bootstrap config.js v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */
var be;
function Xe() {
  return be || (be = 1, function(t, e) {
    (function(r, n) {
      t.exports = n(Qe(), dt());
    })(J, function(r, n) {
      class i {
        // Getters
        static get Default() {
          return {};
        }
        static get DefaultType() {
          return {};
        }
        static get NAME() {
          throw new Error('You have to implement the static method "NAME", for each component!');
        }
        _getConfig(s) {
          return s = this._mergeConfigObj(s), s = this._configAfterMerge(s), this._typeCheckConfig(s), s;
        }
        _configAfterMerge(s) {
          return s;
        }
        _mergeConfigObj(s, a) {
          const l = n.isElement(a) ? r.getDataAttribute(a, "config") : {};
          return {
            ...this.constructor.Default,
            ...typeof l == "object" ? l : {},
            ...n.isElement(a) ? r.getDataAttributes(a) : {},
            ...typeof s == "object" ? s : {}
          };
        }
        _typeCheckConfig(s, a = this.constructor.DefaultType) {
          for (const [l, u] of Object.entries(a)) {
            const f = s[l], E = n.isElement(f) ? "element" : n.toType(f);
            if (!new RegExp(u).test(E))
              throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${l}" provided type "${E}" but expected type "${u}".`);
          }
        }
      }
      return i;
    });
  }(Rt)), Rt.exports;
}
/*!
  * Bootstrap base-component.js v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */
var ye;
function Gr() {
  return ye || (ye = 1, function(t, e) {
    (function(r, n) {
      t.exports = n(Xr(), Ke(), Xe(), dt());
    })(J, function(r, n, i, o) {
      const s = "5.3.3";
      class a extends i {
        constructor(u, f) {
          super(), u = o.getElement(u), u && (this._element = u, this._config = this._getConfig(f), r.set(this._element, this.constructor.DATA_KEY, this));
        }
        // Public
        dispose() {
          r.remove(this._element, this.constructor.DATA_KEY), n.off(this._element, this.constructor.EVENT_KEY);
          for (const u of Object.getOwnPropertyNames(this))
            this[u] = null;
        }
        _queueCallback(u, f, E = !0) {
          o.executeAfterTransition(u, f, E);
        }
        _getConfig(u) {
          return u = this._mergeConfigObj(u, this._element), u = this._configAfterMerge(u), this._typeCheckConfig(u), u;
        }
        // Static
        static getInstance(u) {
          return r.get(o.getElement(u), this.DATA_KEY);
        }
        static getOrCreateInstance(u, f = {}) {
          return this.getInstance(u) || new this(u, typeof f == "object" ? f : null);
        }
        static get VERSION() {
          return s;
        }
        static get DATA_KEY() {
          return `bs.${this.NAME}`;
        }
        static get EVENT_KEY() {
          return `.${this.DATA_KEY}`;
        }
        static eventName(u) {
          return `${u}${this.EVENT_KEY}`;
        }
      }
      return a;
    });
  }(St)), St.exports;
}
var _t = { exports: {} };
/*!
  * Bootstrap sanitizer.js v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */
var _e;
function Ge() {
  return _e || (_e = 1, function(t, e) {
    (function(r, n) {
      n(e);
    })(J, function(r) {
      const i = {
        // Global attributes allowed on any supplied element below.
        "*": ["class", "dir", "id", "lang", "role", /^aria-[\w-]*$/i],
        a: ["target", "href", "title", "rel"],
        area: [],
        b: [],
        br: [],
        col: [],
        code: [],
        dd: [],
        div: [],
        dl: [],
        dt: [],
        em: [],
        hr: [],
        h1: [],
        h2: [],
        h3: [],
        h4: [],
        h5: [],
        h6: [],
        i: [],
        img: ["src", "srcset", "alt", "title", "width", "height"],
        li: [],
        ol: [],
        p: [],
        pre: [],
        s: [],
        small: [],
        span: [],
        sub: [],
        sup: [],
        strong: [],
        u: [],
        ul: []
      }, o = /* @__PURE__ */ new Set(["background", "cite", "href", "itemtype", "longdesc", "poster", "src", "xlink:href"]), s = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i, a = (u, f) => {
        const E = u.nodeName.toLowerCase();
        return f.includes(E) ? o.has(E) ? !!s.test(u.nodeValue) : !0 : f.filter((b) => b instanceof RegExp).some((b) => b.test(E));
      };
      function l(u, f, E) {
        if (!u.length)
          return u;
        if (E && typeof E == "function")
          return E(u);
        const g = new window.DOMParser().parseFromString(u, "text/html"), A = [].concat(...g.body.querySelectorAll("*"));
        for (const _ of A) {
          const T = _.nodeName.toLowerCase();
          if (!Object.keys(f).includes(T)) {
            _.remove();
            continue;
          }
          const S = [].concat(..._.attributes), P = [].concat(f["*"] || [], f[T] || []);
          for (const D of S)
            a(D, P) || _.removeAttribute(D.nodeName);
        }
        return g.body.innerHTML;
      }
      r.DefaultAllowlist = i, r.sanitizeHtml = l, Object.defineProperty(r, Symbol.toStringTag, { value: "Module" });
    });
  }(_t, _t.exports)), _t.exports;
}
var Mt = { exports: {} }, It = { exports: {} };
/*!
  * Bootstrap selector-engine.js v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */
var we;
function Jr() {
  return we || (we = 1, function(t, e) {
    (function(r, n) {
      t.exports = n(dt());
    })(J, function(r) {
      const n = (o) => {
        let s = o.getAttribute("data-bs-target");
        if (!s || s === "#") {
          let a = o.getAttribute("href");
          if (!a || !a.includes("#") && !a.startsWith("."))
            return null;
          a.includes("#") && !a.startsWith("#") && (a = `#${a.split("#")[1]}`), s = a && a !== "#" ? a.trim() : null;
        }
        return s ? s.split(",").map((a) => r.parseSelector(a)).join(",") : null;
      }, i = {
        find(o, s = document.documentElement) {
          return [].concat(...Element.prototype.querySelectorAll.call(s, o));
        },
        findOne(o, s = document.documentElement) {
          return Element.prototype.querySelector.call(s, o);
        },
        children(o, s) {
          return [].concat(...o.children).filter((a) => a.matches(s));
        },
        parents(o, s) {
          const a = [];
          let l = o.parentNode.closest(s);
          for (; l; )
            a.push(l), l = l.parentNode.closest(s);
          return a;
        },
        prev(o, s) {
          let a = o.previousElementSibling;
          for (; a; ) {
            if (a.matches(s))
              return [a];
            a = a.previousElementSibling;
          }
          return [];
        },
        // TODO: this is now unused; remove later along with prev()
        next(o, s) {
          let a = o.nextElementSibling;
          for (; a; ) {
            if (a.matches(s))
              return [a];
            a = a.nextElementSibling;
          }
          return [];
        },
        focusableChildren(o) {
          const s = ["a", "button", "input", "textarea", "select", "details", "[tabindex]", '[contenteditable="true"]'].map((a) => `${a}:not([tabindex^="-"])`).join(",");
          return this.find(s, o).filter((a) => !r.isDisabled(a) && r.isVisible(a));
        },
        getSelectorFromElement(o) {
          const s = n(o);
          return s && i.findOne(s) ? s : null;
        },
        getElementFromSelector(o) {
          const s = n(o);
          return s ? i.findOne(s) : null;
        },
        getMultipleElementsFromSelector(o) {
          const s = n(o);
          return s ? i.find(s) : [];
        }
      };
      return i;
    });
  }(It)), It.exports;
}
/*!
  * Bootstrap template-factory.js v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */
var Ee;
function Zr() {
  return Ee || (Ee = 1, function(t, e) {
    (function(r, n) {
      t.exports = n(Jr(), Xe(), Ge(), dt());
    })(J, function(r, n, i, o) {
      const s = "TemplateFactory", a = {
        allowList: i.DefaultAllowlist,
        content: {},
        // { selector : text ,  selector2 : text2 , }
        extraClass: "",
        html: !1,
        sanitize: !0,
        sanitizeFn: null,
        template: "<div></div>"
      }, l = {
        allowList: "object",
        content: "object",
        extraClass: "(string|function)",
        html: "boolean",
        sanitize: "boolean",
        sanitizeFn: "(null|function)",
        template: "string"
      }, u = {
        entry: "(string|element|function|null)",
        selector: "(string|element)"
      };
      class f extends n {
        constructor(b) {
          super(), this._config = this._getConfig(b);
        }
        // Getters
        static get Default() {
          return a;
        }
        static get DefaultType() {
          return l;
        }
        static get NAME() {
          return s;
        }
        // Public
        getContent() {
          return Object.values(this._config.content).map((b) => this._resolvePossibleFunction(b)).filter(Boolean);
        }
        hasContent() {
          return this.getContent().length > 0;
        }
        changeContent(b) {
          return this._checkContent(b), this._config.content = {
            ...this._config.content,
            ...b
          }, this;
        }
        toHtml() {
          const b = document.createElement("div");
          b.innerHTML = this._maybeSanitize(this._config.template);
          for (const [_, T] of Object.entries(this._config.content))
            this._setContent(b, T, _);
          const g = b.children[0], A = this._resolvePossibleFunction(this._config.extraClass);
          return A && g.classList.add(...A.split(" ")), g;
        }
        // Private
        _typeCheckConfig(b) {
          super._typeCheckConfig(b), this._checkContent(b.content);
        }
        _checkContent(b) {
          for (const [g, A] of Object.entries(b))
            super._typeCheckConfig({
              selector: g,
              entry: A
            }, u);
        }
        _setContent(b, g, A) {
          const _ = r.findOne(A, b);
          if (_) {
            if (g = this._resolvePossibleFunction(g), !g) {
              _.remove();
              return;
            }
            if (o.isElement(g)) {
              this._putElementInTemplate(o.getElement(g), _);
              return;
            }
            if (this._config.html) {
              _.innerHTML = this._maybeSanitize(g);
              return;
            }
            _.textContent = g;
          }
        }
        _maybeSanitize(b) {
          return this._config.sanitize ? i.sanitizeHtml(b, this._config.allowList, this._config.sanitizeFn) : b;
        }
        _resolvePossibleFunction(b) {
          return o.execute(b, [this]);
        }
        _putElementInTemplate(b, g) {
          if (this._config.html) {
            g.innerHTML = "", g.append(b);
            return;
          }
          g.textContent = b.textContent;
        }
      }
      return f;
    });
  }(Mt)), Mt.exports;
}
/*!
  * Bootstrap tooltip.js v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */
(function(t, e) {
  (function(r, n) {
    t.exports = n(Qr, Gr(), Ke(), Qe(), dt(), Ge(), Zr());
  })(J, function(r, n, i, o, s, a, l) {
    function u(F) {
      const d = Object.create(null, { [Symbol.toStringTag]: { value: "Module" } });
      if (F) {
        for (const x in F)
          if (x !== "default") {
            const M = Object.getOwnPropertyDescriptor(F, x);
            Object.defineProperty(d, x, M.get ? M : {
              enumerable: !0,
              get: () => F[x]
            });
          }
      }
      return d.default = F, Object.freeze(d);
    }
    const f = /* @__PURE__ */ u(r), E = "tooltip", b = /* @__PURE__ */ new Set(["sanitize", "allowList", "sanitizeFn"]), g = "fade", A = "modal", _ = "show", T = ".tooltip-inner", S = `.${A}`, P = "hide.bs.modal", D = "hover", O = "focus", N = "click", p = "manual", h = "hide", y = "hidden", w = "show", c = "shown", v = "inserted", m = "click", C = "focusin", R = "focusout", I = "mouseenter", L = "mouseleave", $ = {
      AUTO: "auto",
      TOP: "top",
      RIGHT: s.isRTL() ? "left" : "right",
      BOTTOM: "bottom",
      LEFT: s.isRTL() ? "right" : "left"
    }, j = {
      allowList: a.DefaultAllowlist,
      animation: !0,
      boundary: "clippingParents",
      container: !1,
      customClass: "",
      delay: 0,
      fallbackPlacements: ["top", "right", "bottom", "left"],
      html: !1,
      offset: [0, 6],
      placement: "top",
      popperConfig: null,
      sanitize: !0,
      sanitizeFn: null,
      selector: !1,
      template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
      title: "",
      trigger: "hover focus"
    }, Y = {
      allowList: "object",
      animation: "boolean",
      boundary: "(string|element)",
      container: "(string|element|boolean)",
      customClass: "(string|function)",
      delay: "(number|object)",
      fallbackPlacements: "array",
      html: "boolean",
      offset: "(array|string|function)",
      placement: "(string|function)",
      popperConfig: "(null|object|function)",
      sanitize: "boolean",
      sanitizeFn: "(null|function)",
      selector: "(string|boolean)",
      template: "string",
      title: "(string|element|function)",
      trigger: "string"
    };
    class Q extends n {
      constructor(d, x) {
        if (typeof f > "u")
          throw new TypeError("Bootstrap's tooltips require Popper (https://popper.js.org)");
        super(d, x), this._isEnabled = !0, this._timeout = 0, this._isHovered = null, this._activeTrigger = {}, this._popper = null, this._templateFactory = null, this._newContent = null, this.tip = null, this._setListeners(), this._config.selector || this._fixTitle();
      }
      // Getters
      static get Default() {
        return j;
      }
      static get DefaultType() {
        return Y;
      }
      static get NAME() {
        return E;
      }
      // Public
      enable() {
        this._isEnabled = !0;
      }
      disable() {
        this._isEnabled = !1;
      }
      toggleEnabled() {
        this._isEnabled = !this._isEnabled;
      }
      toggle() {
        if (this._isEnabled) {
          if (this._activeTrigger.click = !this._activeTrigger.click, this._isShown()) {
            this._leave();
            return;
          }
          this._enter();
        }
      }
      dispose() {
        clearTimeout(this._timeout), i.off(this._element.closest(S), P, this._hideModalHandler), this._element.getAttribute("data-bs-original-title") && this._element.setAttribute("title", this._element.getAttribute("data-bs-original-title")), this._disposePopper(), super.dispose();
      }
      show() {
        if (this._element.style.display === "none")
          throw new Error("Please use show on visible elements");
        if (!(this._isWithContent() && this._isEnabled))
          return;
        const d = i.trigger(this._element, this.constructor.eventName(w)), M = (s.findShadowRoot(this._element) || this._element.ownerDocument.documentElement).contains(this._element);
        if (d.defaultPrevented || !M)
          return;
        this._disposePopper();
        const k = this._getTipElement();
        this._element.setAttribute("aria-describedby", k.getAttribute("id"));
        const {
          container: q
        } = this._config;
        if (this._element.ownerDocument.documentElement.contains(this.tip) || (q.append(k), i.trigger(this._element, this.constructor.eventName(v))), this._popper = this._createPopper(k), k.classList.add(_), "ontouchstart" in document.documentElement)
          for (const Z of [].concat(...document.body.children))
            i.on(Z, "mouseover", s.noop);
        const V = () => {
          i.trigger(this._element, this.constructor.eventName(c)), this._isHovered === !1 && this._leave(), this._isHovered = !1;
        };
        this._queueCallback(V, this.tip, this._isAnimated());
      }
      hide() {
        if (!this._isShown() || i.trigger(this._element, this.constructor.eventName(h)).defaultPrevented)
          return;
        if (this._getTipElement().classList.remove(_), "ontouchstart" in document.documentElement)
          for (const k of [].concat(...document.body.children))
            i.off(k, "mouseover", s.noop);
        this._activeTrigger[N] = !1, this._activeTrigger[O] = !1, this._activeTrigger[D] = !1, this._isHovered = null;
        const M = () => {
          this._isWithActiveTrigger() || (this._isHovered || this._disposePopper(), this._element.removeAttribute("aria-describedby"), i.trigger(this._element, this.constructor.eventName(y)));
        };
        this._queueCallback(M, this.tip, this._isAnimated());
      }
      update() {
        this._popper && this._popper.update();
      }
      // Protected
      _isWithContent() {
        return !!this._getTitle();
      }
      _getTipElement() {
        return this.tip || (this.tip = this._createTipElement(this._newContent || this._getContentForTemplate())), this.tip;
      }
      _createTipElement(d) {
        const x = this._getTemplateFactory(d).toHtml();
        if (!x)
          return null;
        x.classList.remove(g, _), x.classList.add(`bs-${this.constructor.NAME}-auto`);
        const M = s.getUID(this.constructor.NAME).toString();
        return x.setAttribute("id", M), this._isAnimated() && x.classList.add(g), x;
      }
      setContent(d) {
        this._newContent = d, this._isShown() && (this._disposePopper(), this.show());
      }
      _getTemplateFactory(d) {
        return this._templateFactory ? this._templateFactory.changeContent(d) : this._templateFactory = new l({
          ...this._config,
          // the `content` var has to be after `this._config`
          // to override config.content in case of popover
          content: d,
          extraClass: this._resolvePossibleFunction(this._config.customClass)
        }), this._templateFactory;
      }
      _getContentForTemplate() {
        return {
          [T]: this._getTitle()
        };
      }
      _getTitle() {
        return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute("data-bs-original-title");
      }
      // Private
      _initializeOnDelegatedTarget(d) {
        return this.constructor.getOrCreateInstance(d.delegateTarget, this._getDelegateConfig());
      }
      _isAnimated() {
        return this._config.animation || this.tip && this.tip.classList.contains(g);
      }
      _isShown() {
        return this.tip && this.tip.classList.contains(_);
      }
      _createPopper(d) {
        const x = s.execute(this._config.placement, [this, d, this._element]), M = $[x.toUpperCase()];
        return f.createPopper(this._element, d, this._getPopperConfig(M));
      }
      _getOffset() {
        const {
          offset: d
        } = this._config;
        return typeof d == "string" ? d.split(",").map((x) => Number.parseInt(x, 10)) : typeof d == "function" ? (x) => d(x, this._element) : d;
      }
      _resolvePossibleFunction(d) {
        return s.execute(d, [this._element]);
      }
      _getPopperConfig(d) {
        const x = {
          placement: d,
          modifiers: [{
            name: "flip",
            options: {
              fallbackPlacements: this._config.fallbackPlacements
            }
          }, {
            name: "offset",
            options: {
              offset: this._getOffset()
            }
          }, {
            name: "preventOverflow",
            options: {
              boundary: this._config.boundary
            }
          }, {
            name: "arrow",
            options: {
              element: `.${this.constructor.NAME}-arrow`
            }
          }, {
            name: "preSetPlacement",
            enabled: !0,
            phase: "beforeMain",
            fn: (M) => {
              this._getTipElement().setAttribute("data-popper-placement", M.state.placement);
            }
          }]
        };
        return {
          ...x,
          ...s.execute(this._config.popperConfig, [x])
        };
      }
      _setListeners() {
        const d = this._config.trigger.split(" ");
        for (const x of d)
          if (x === "click")
            i.on(this._element, this.constructor.eventName(m), this._config.selector, (M) => {
              this._initializeOnDelegatedTarget(M).toggle();
            });
          else if (x !== p) {
            const M = x === D ? this.constructor.eventName(I) : this.constructor.eventName(C), k = x === D ? this.constructor.eventName(L) : this.constructor.eventName(R);
            i.on(this._element, M, this._config.selector, (q) => {
              const V = this._initializeOnDelegatedTarget(q);
              V._activeTrigger[q.type === "focusin" ? O : D] = !0, V._enter();
            }), i.on(this._element, k, this._config.selector, (q) => {
              const V = this._initializeOnDelegatedTarget(q);
              V._activeTrigger[q.type === "focusout" ? O : D] = V._element.contains(q.relatedTarget), V._leave();
            });
          }
        this._hideModalHandler = () => {
          this._element && this.hide();
        }, i.on(this._element.closest(S), P, this._hideModalHandler);
      }
      _fixTitle() {
        const d = this._element.getAttribute("title");
        d && (!this._element.getAttribute("aria-label") && !this._element.textContent.trim() && this._element.setAttribute("aria-label", d), this._element.setAttribute("data-bs-original-title", d), this._element.removeAttribute("title"));
      }
      _enter() {
        if (this._isShown() || this._isHovered) {
          this._isHovered = !0;
          return;
        }
        this._isHovered = !0, this._setTimeout(() => {
          this._isHovered && this.show();
        }, this._config.delay.show);
      }
      _leave() {
        this._isWithActiveTrigger() || (this._isHovered = !1, this._setTimeout(() => {
          this._isHovered || this.hide();
        }, this._config.delay.hide));
      }
      _setTimeout(d, x) {
        clearTimeout(this._timeout), this._timeout = setTimeout(d, x);
      }
      _isWithActiveTrigger() {
        return Object.values(this._activeTrigger).includes(!0);
      }
      _getConfig(d) {
        const x = o.getDataAttributes(this._element);
        for (const M of Object.keys(x))
          b.has(M) && delete x[M];
        return d = {
          ...x,
          ...typeof d == "object" && d ? d : {}
        }, d = this._mergeConfigObj(d), d = this._configAfterMerge(d), this._typeCheckConfig(d), d;
      }
      _configAfterMerge(d) {
        return d.container = d.container === !1 ? document.body : s.getElement(d.container), typeof d.delay == "number" && (d.delay = {
          show: d.delay,
          hide: d.delay
        }), typeof d.title == "number" && (d.title = d.title.toString()), typeof d.content == "number" && (d.content = d.content.toString()), d;
      }
      _getDelegateConfig() {
        const d = {};
        for (const [x, M] of Object.entries(this._config))
          this.constructor.Default[x] !== M && (d[x] = M);
        return d.selector = !1, d.trigger = "manual", d;
      }
      _disposePopper() {
        this._popper && (this._popper.destroy(), this._popper = null), this.tip && (this.tip.remove(), this.tip = null);
      }
      // Static
      static jQueryInterface(d) {
        return this.each(function() {
          const x = Q.getOrCreateInstance(this, d);
          if (typeof d == "string") {
            if (typeof x[d] > "u")
              throw new TypeError(`No method named "${d}"`);
            x[d]();
          }
        });
      }
    }
    return s.defineJQueryPlugin(Q), Q;
  });
})(Oe);
var tn = Oe.exports;
const en = /* @__PURE__ */ or(tn), on = {
  install: (t, e = {}) => {
    const r = {
      Tooltip: en
    };
    e.locale && sr(e.locale), t.provide("bootstrap", r), t.directive("tooltip", {
      mounted: (n, i) => {
        n.tooltipInstance = new r.Tooltip(n, {
          title: i.value.value || " ",
          customClass: i.value.customClass || ""
        }), i.value.value ? n.tooltipInstance.enable() : n.tooltipInstance.disable();
      },
      updated: (n, i) => {
        i.value.value ? (n.tooltipInstance.setContent({
          ".tooltip-inner": i.value.value
        }), n.tooltipInstance.enable()) : n.tooltipInstance.disable();
      }
    });
  }
};
export {
  on as default,
  sr as setLibraryLocale
};
